/* Import global CSS */

import "./src/components/_global.scss"
